<template>
    <div>
        <div class="form-group">
            <label>
                Delivery Phase & Company:
                <select-input
                    v-model="phase"
                    name="phase_type"
                    :options="phaseOptions"
                    :required="true"
                    :opt-out-sorting="true"
                />
            </label>
        </div>
        <div class="form-group">
            <label>
                Invoice Amount:
                <input
                    :disabled="isDisabled"
                    name="amount"
                    type="number"
                    :value="balancePerPhase[phase]"
                    required="required"
                    class="form-input block"
                >
            </label>
        </div>
        <input
            v-if="isDisabled"
            name="amount"
            type="hidden"
            :value="balancePerPhase[phase]"
        >
    </div>
</template>

<script>
    export default {
        props: {
            balancePerPhase: {
                type: Object,
                required: true,
            },
            isDisabled: {
                type: Boolean,
                default: false,
            },
            phaseOptions: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                amount:  this.initialPercentages,
                phase: null,
            };
        },

        computed: {
        },

        methods: {
        },
    };
</script>
